export default __webpack_public_path__ + "static/media/beer.ff6491de.svg";